import React, { useState, useEffect } from 'react';
import { Grid, Box, TextField, Button, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useDispatch, useSelector } from 'react-redux';
import TestsRequests from 'services/tests';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Add } from '@material-ui/icons';
import MiniTestsList from './minitTestsList';
import { setCreatedQuiz, setMiniGamesList } from 'redux/actions/Tests';
import { useHistory } from 'react-router';

const useStyles = makeStyles(_ => ({
  autoCompleteContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiOutlinedInput-root': {
      borderTopRightRadius: '0px !important',
      borderBottomRightRadius: '0px !important',
    },
  },
  autoCompleteStyle: {
    width: '100%',
  },
  submitButton: {
    height: '56px !important',
    marginTop: '8px',
    borderTopLeftRadius: '0px !important',
    borderBottomLeftRadius: '0px !important',
  },
}));

const MiniQuizes = ({ receivedQuizes }) => {
  const classes = useStyles();
  const [autoCompleteTextFieldData, setAutoCompleteTextFieldData] = useState('');
  const [autoCompleteTextFieldDataId, setAutoCompleteTextFieldDataID] = useState('');
  const [miniQuizes, setMiniQuizes] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const history = useHistory();

  const dispatch = useDispatch();
  const { allTests, miniGamesList, createdQuiz } = useSelector(({ tests }) => tests);

  useEffect(() => {
    dispatch(TestsRequests.getAllTests());
    dispatch(setMiniGamesList([]));
    dispatch(setCreatedQuiz({}));
  }, []);

  useEffect(() => {
    if (miniQuizes !== miniGamesList) {
      dispatch(setMiniGamesList(miniQuizes));
    }
  }, [miniQuizes, miniGamesList]);

  useEffect(() => {
    if (receivedQuizes.length !== 0) {
      setMiniQuizes(receivedQuizes);
    }
  }, [receivedQuizes]);

  useEffect(() => {
    setTimeout(() => {
      if (createdQuiz !== null) {
        if (createdQuiz.hasOwnProperty('id')) {
          history.replace('/tests');
        }
      }
    }, 500);
  }, [createdQuiz]);

  const handleAutoCompleteInputChange = e => {
    if (e !== null) {
      if (typeof e.target.value === 'string') {
        setInputValue(e.target.value);
      }
    }
  };

  const handleSubmitQuestion = () => {
    const temp = [...miniQuizes];
    if (autoCompleteTextFieldData && autoCompleteTextFieldDataId) {
      const data = {
        id: autoCompleteTextFieldDataId,
        quiz: autoCompleteTextFieldData,
      };
      let duplicatedQuesiton = false;
      miniQuizes.forEach(element => {
        if (element.id === autoCompleteTextFieldDataId) {
          duplicatedQuesiton = true;
        }
      });
      if (!duplicatedQuesiton) {
        temp.push(data);
        setMiniQuizes(temp);
        setAutoCompleteTextFieldData('');
      }
      setAutoCompleteTextFieldData('');
      setInputValue('');
    }
  };

  const updateQuiz = q => {
    setMiniQuizes(q);
  };

  return (
    <>
      <Grid item xs={12}>
        <Box className={classes.autoCompleteContainer}>
          <Autocomplete
            inputValue={inputValue}
            onChange={(_, newValue) => {
              if (newValue) {
                setAutoCompleteTextFieldData(newValue.title);
                setInputValue(newValue.title);
                setAutoCompleteTextFieldDataID(newValue._id);
              } else {
                setAutoCompleteTextFieldData('');
              }
            }}
            onInputChange={handleAutoCompleteInputChange}
            className={classes.autoCompleteStyle}
            noOptionsText={'موردی یافت نشد'}
            id="free-solo-demo"
            getOptionLabel={option => option.title}
            options={allTests}
            renderInput={params => <TextField {...params} label="مینی گیم" margin="normal" variant="outlined" />}
          />
          <Button variant="contained" color="primary" className={classes.submitButton} onClick={handleSubmitQuestion}>
            <Add />
          </Button>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box display={'flex'} alignItems="center">
          <Box marginLeft={2}>{miniQuizes.length !== 0 && <Typography>مینی کوییزها</Typography>}</Box>
        </Box>
        {miniQuizes.length !== 0 ? <MiniTestsList data={miniQuizes} updateData={q => updateQuiz(q)} /> : null}
      </Grid>
    </>
  );
};

export default MiniQuizes;
